<template>
  <div class="itinerary-box">
    <p>没有符合的行程单，</p>
    <p>以下为行程单相关截图、照片等凭证</p>
    <div class="imglist" v-if="imglist && imglist.length > 0">
      <img v-for="(i, index) in imglist" @click="open(index)" :key="index" :src="i" alt="">
    </div>
    <div v-else style="line-height: 0.533333rem;font-size: 0.373333rem;margin-top: 10px;">无相关凭证</div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import { ImagePreview } from 'vant';

    export default {
        data () {
            return {
                imglist: []
            }
        },
        created () {
            this.imglist = this.$route.query.imgs

            console.log(this.imglist, '5555')
            // try {
            //   let newStr = this.$route.query.imgs
            //   if (newStr) {
            //     newStr = newStr.substring(1, newStr.length - 1)
            //     if (newStr) {
            //       this.imglist = newStr.split(',')
            //     }
            //   } else {
            //     this.imglist = []
            //   }
            // } catch (err) {
            // }
        },
        methods: {
            open (index) {
                window.history.pushState(null, null, "#");
                const that = this
                // const imgList = []
                // if (this.imglist.length > 0) {
                //   this.imglist.map(i => {
                //     imgList.push(i.fileUrl)
                //   })
                // }
                const imglist = this.imglist
                ImagePreview({
                    images: imglist,
                    startPosition: index,
                      onClose() {
                      console.log('window.location.href', window.location.href);
                      if (window.location.href.indexOf('itinerary') === -1) {
                        that.$router.back()
                      }
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
  .itinerary-box {
    padding: 20px 16px 0;
    p {
      line-height: 20px;
      font-size: 14px;
      color: #242629;
      font-weight: 400;
    }
    .imglist {
      display: flex;
      margin-top: 20px;
      flex-wrap: wrap;
      img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        margin: 0 10px 10px;
      }
    }
  }
</style>
